import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import { useEffect, useState } from "react";
import DefineParameters from "./Components/DefineParameters";
import FunctionDefinition from "./Components/FunctionDefinition";
import styles from "./Functions.module.css";
import Badge from "@material-ui/core/Badge";
import helpDirection from "../../Resources/helpDirection.json"
import { useTranslation } from "react-i18next";
import { handleWinObjects } from "../../components/IFormDesignerLayout/ReUsableLogics";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    margin: "4px",
    border: "1px solid #C4C4C4",
    "& .MuiChip-root": {
      borderRadius: 2,
      width: "35%",
      height: "25px",
      backgroundColor: "#F0F0F0",
    },
    "& .MuiButtonBase-root": {
      margin: "0 !important",
    },
    "& .MuiInputBase-input": {
      border: "none !important",
      width: "75% !important",
      flexGrow: "0",
    },
    "& .MuiAutocomplete-endAdornment": {
      right:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      left:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "-183px"
          : null,
    },
    "& .MuiChip-deleteIcon": {
      marginRight:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      marginLeft:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "5px"
          : null,
    },
  },
  table: {
    minWidth: "100%",
  },
  tooltip: {
    maxWidth: "160px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
  dialogPaper: {
    minWidth: "950px",
    borderRadius: "2px",
    overflowX: "hidden",
  },
  dialogHeader: {
    fontWeight: "bold",
    padding: "10px",
    fontSize: "14px",
  },
  dialogSubHeading: {
    width: "100%",
    height: "1px",
    backgroundColor: "#F0F0F0",
    fontSize: "12px",
    fontWeight: "bold",
    border: "1px solid #d7d7d7",
  },
  dialogFooter: {
    position: "relative",
    display: "flex",
    "justify-content": "space-between",
    padding: "10px",
    bottom: 0,
    width: "100%",
    "background-color": "#f0f0f0",
  },
  dialogContent: {
    width: "100%",
    justifyContent: "space-between",
    fontFamily: "Open Sans !important",
    fontSize: "14px !important",
  },
  dialogContentMethod: {
    width: "58%",
    justifyContent: "space-between",
    fontFamily: "Open Sans !important",
    fontSize: "14px !important",
    display: "flex",
  },
  cancelButton: {
    cursor: "pointer",
    "border-radius": "0px",
    border: "1px solid grey",
    width: "60px",
    height: "30px",
    margin: "0px 10px",
  },
  publishButton: {
    cursor: "pointer",
    "border-radius": "0px",
    border: "1px solid blue",
    width: "60px",
    height: "30px",
    margin: "0px 10px",
  },
  inputField: {
    borderRadius: "10px",
    width: "350px",
  },
  inputBox: {
    marginLeft: "10px",
    borderRadius: "10px",
    width: "430px",
    display: "block",
    overflowY: "auto",
  },
  bodyTab1: {
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    font: "normal normal 600 12px/17px Open Sans;",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  tab: {
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
  activeTab: {
    color: "var(--brand_color2)",
    paddingBottom: "7px",
    borderBottom: "3px solid var(--brand_color2)",
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
}));

const ReusableBusinessFunction = ({
  isMF,
  functionName,
  endpointURL,
  inputDataObjects,
  setInputDataObjects,
  outputDataObjects,
  setOutputDataObjects,
  isDefineParameters,
  setIsDefineParameters,
  prevValue,
}) => {
  const classes = useStyles();

  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [display, setDisplay] = useState(true);

  window.loading = (val,display=true,mess="") => {
    setOpen(val);
    setMessage(mess);
    setDisplay(display)
    if(val === false || val === "false") {
        if(window.formBuilderCheck)
            window?.formBuilderCheck();
    } 
}

  useEffect(() => {
    if (functionName.current !== "" && endpointURL.current !== "") {
      setIsDefineParameters(true);
    }
  }, []);

  return (
    <div className={styles.container} style={{ direction: translationStyles1 ? "rtl" : "ltr" }}>
      <div className={classes.dialogHeader} style={translationStyles1 ? {textAlign: "right"} : null}>
        <span>{t("translation:Business_Function")}</span>
        <Badge  color="secondary"  style={{margin:"8px"}}>
              <img
              tabIndex={0}
                src={require("../../Icons/Help20.svg").default}
                alt="help" 
                onClick={()=>{ 
                 const newWin =  window.open(`/webhelp/resources/interface_designer?rhmapno=${helpDirection?.["businessFunction"]}`)
                  handleWinObjects(newWin);
                }}
                target="_blank"
                style={{width:"20px",height:"20px",cursor:"pointer"}}
              />
            </Badge>
      </div>
      <div className={classes.dialogSubHeading}></div>
      <TableContainer style={{ padding: "15px" }}>
        <Table className={classes.table} aria-label="business function table">
          <TableBody>
            <FunctionDefinition
              isMF={isMF}
              prevValue={prevValue}
              functionName={functionName}
              endpointURL={endpointURL}
              isDefineParameters={isDefineParameters}
              setIsDefineParameters={setIsDefineParameters}
            />

            <DefineParameters
              isMF={isMF}
              prevValue={prevValue}
              inputDataObjects={inputDataObjects}
              setInputDataObjects={setInputDataObjects}
              outputDataObjects={outputDataObjects}
              setOutputDataObjects={setOutputDataObjects}
              endpointURL={endpointURL}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ReusableBusinessFunction;
